import { Outlet } from 'react-router-dom'
import { MenuBar } from 'src/components'

/**
 * 以微前端方式加载的布局
 * @param props 
 * @returns 
 */
const MicroMain = () => {
  return (
    <div className='main'>
      <div className='main__body'>
        <div className='main__body-content'><Outlet /></div>
      </div>
      <MenuBar />
    </div>
  )
}

export default MicroMain